// Ana sayfa "Bekleyen İşlerim" kartı: kullanıcıya atanmış cor_tasks kayıtları.
// Satıra tıklayınca görevin navigate_to hedefine gider; tam liste /tasks sayfasında.

import React from 'react';
import { Badge, Button, Card, Spin, Tag, Tooltip } from 'antd';
import { CarryOutOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useAuth } from '../security/AuthContext';
import { useAssignedTasks } from './useAssignedTasks';
import type { CorTask } from '../../../types';

dayjs.extend(relativeTime);

const MAX_VISIBLE = 6;

const PendingTasksCard: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { tasks, count, isLoading, navigateToTask } = useAssignedTasks();

  const purposeTag = (task: CorTask) =>
    task?.context?.purpose === 'notify'
      ? <Tag color="blue" style={{ marginRight: 0 }}>{t('tasks.typeNotify')}</Tag>
      : <Tag color="orange" style={{ marginRight: 0 }}>{t('tasks.typeAction')}</Tag>;

  return (
    <Card className="cc-tasks-card" bordered={false}>
      <div className="cc-tasks-header">
        <CarryOutOutlined style={{ fontSize: 20, marginRight: 8 }} />
        <span className="cc-card-title">{t('home.myTasks')}</span>
        {user && count > 0 && (
          <Badge count={count} overflowCount={99} style={{ backgroundColor: '#faad14', marginLeft: 8 }} />
        )}
      </div>
      {!user ? (
        <div className="cc-tasks-note">{t('home.tasksLoginPrompt')}</div>
      ) : isLoading ? (
        <div style={{ textAlign: 'center', padding: 16 }}><Spin size="small" /></div>
      ) : count === 0 ? (
        <div className="cc-tasks-note">{t('home.tasksEmpty')}</div>
      ) : (
        <>
          <div className="cc-tasks-list">
            {tasks.slice(0, MAX_VISIBLE).map(task => (
              <div key={task.id} className="cc-task-row" onClick={() => navigateToTask(navigate, task)}>
                {purposeTag(task)}
                <Tooltip title={task.description}>
                  <span className="cc-task-desc">{task.description}</span>
                </Tooltip>
                {task.created_at && (
                  <span className="cc-task-age">{dayjs(task.created_at).fromNow()}</span>
                )}
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 8 }}>
            <Button type="link" size="small" onClick={() => navigate('/tasks')}>
              {t('home.viewAllTasks')} ({count}) <RightOutlined />
            </Button>
          </div>
        </>
      )}
    </Card>
  );
};

export default PendingTasksCard;
